import { useContext } from 'react'

import SearchFilterContext from 'context/searchFilterContext'

import { FilterIndex } from 'constants/search-data/search-data'

const UseOpenMobileFilters = () => {
  const { setFilter } = useContext(SearchFilterContext)
  const handleChangeFilter = () => setFilter()
  const handleCloseFilter = () => setFilter(FilterIndex.TURN_OFF_INDEX)

  return { handleChangeFilter, handleCloseFilter }
}

export default UseOpenMobileFilters
